import { ScrollArea } from '@mantine/core';
import { scrollAreaRecipe } from '@recipes';

export default ScrollArea.withProps({ classNames: scrollAreaRecipe() });
